import React from 'react';
import { motion } from 'framer-motion';
export function Imagine30Days() {
  const outcomes = ['Más tranquilo/a.', 'Más enfocado/a.', 'Más agradecido/a.', 'Más conectado/a con Dios.', 'Más consciente de Su presencia en cada área de tu vida.', 'Más seguro/a de Sus promesas — no como algo que lees, sino como algo que vives.'];
  return <section className="w-full bg-gradient-to-b from-[#0A1535] to-[#0B1A3A] py-20 px-6" style={{
    backgroundImage: "linear-gradient(180deg, #5B401F 0%, #5B401F 100%)"
  }} data-id="element-147" data-mp="cq1e3bp5jfat">
      <div className="max-w-3xl mx-auto text-center" data-id="element-148" data-mp="14jjvs46pxlcm">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-149" data-mp="10gxbqpgah4pz">
          Imagina cómo te sentirás dentro de 30 días
        </motion.h2>

        <div className="space-y-4 mb-8" data-id="element-150" data-mp="3g7rxn7pb9lku">
          {outcomes.map((outcome, index) => <motion.p key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-xl text-[#E0B756] font-semibold" data-id="element-151" data-mp="2bqu4uu05hksh" data-mpi={index}>
              {outcome}
            </motion.p>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-lg text-gray-300 leading-relaxed" style={{
        color: "#F7F2E7"
      }} data-id="element-152" data-mp="1t0ksirangcn2">
          Y con herramientas y hábitos que podrás seguir utilizando durante toda
          tu vida.
        </motion.p>
      </div>
    </section>;
}